export default {
  refund: {
    drawerTitle: 'استرداد پول به مشتری',
    drawerTitleFa: 'استرداد پول',
    menuTitle: 'استرداد پول به مشتری',
    menuSubtitle: 'Refund to customer',
    accessDenied: 'شما اجازه استرداد پول به مشتری را ندارید.',
    retryQueued: 'استرداد دوباره به کویک‌بوکس فرستاده شد',
    close: 'بستن',
    posted: 'ثبت شده',
    // Customer
    searchCustomerPlaceholder: 'جستجوی مشتری بر اساس نام، نام کاربری، شماره تماس یا قرارداد…',
    searching: 'در حال جستجو…',
    typeTwoChars: 'حداقل ۲ حرف بنویسید',
    noCustomerFound: 'مشتری یافت نشد.',
    pickCustomer: 'مشتری‌ای را که پولش برگردانده می‌شود انتخاب کنید',
    change: 'تغییر',
    balance: 'بیلانس',
    balanceCredit: 'طلبکار',
    balanceOwes: 'بدهکار',
    balanceSettled: 'تسویه',
    loadingSources: 'در حال خواندن پرداخت‌ها و فاکتورها از کویک‌بوکس…',
    tryAgain: 'دوباره تلاش کنید',
    emptyTitle: 'برای این مشتری مبلغ قابل استردادی وجود ندارد',
    emptyDesc: 'در {days} روز اخیر هیچ پرداختی با مبلغ قابل برگشت یافت نشد. استرداد فقط از پولی ممکن است که مشتری واقعاً پرداخته است.',
    searchOlder: 'جستجوی پرداخت‌های قدیمی‌تر',
    loadMetaFailed: 'موقعیت‌ها و کلاس‌ها از کویک‌بوکس بارگذاری نشد',
    // Transaction details
    detailsTitle: 'مشخصات ترانزکشن',
    detailsTitleFa: 'مشخصات ترانزکشن',
    edit: 'ویرایش',
    done: 'تمام',
    fixDateFirst: 'اول تاریخ را اصلاح کنید',
    branch: 'نمایندگی',
    date: 'تاریخ',
    formNo: 'شماره فرم',
    formNext: 'بعدی',
    formAssigned: '✓ تخصیص یافت',
    location: 'موقعیت (Location)',
    className: 'کلاس (Class)',
    pickLocation: 'موقعیت را انتخاب کنید',
    pickClass: 'کلاس را انتخاب کنید',
    dateToday: '{solar} · امروز',
    dateBackDated: '{solar} · تاریخ گذشته · دلیل را در یادداشت بنویسید',
    dateErrPick: 'تاریخ را انتخاب کنید',
    dateErrFuture: 'تاریخ در آینده است',
    dateErrClosed: 'دفاتر تا {date} بسته شده است',
    dateErrCashDay: 'روز صندوق {date} بسته شده است',
    flagDateProblem: 'مشکل تاریخ',
    flagBackDated: 'تاریخ گذشته',
    // 1 · Refund check
    checkTitle: '۱ · چک استرداد',
    checkTitleFa: 'پولی که به مشتری برمی‌گردد',
    checkBadge: 'مصرف روی حساب دریافتنی (A/R)',
    fromPayment: 'از پرداخت',
    payOnNone: 'به هیچ فاکتوری اعمال نشده · طلب مشتری',
    payOnSplit: '{applied} روی {doc} · {free} اضافه',
    payOn: 'روی {doc}',
    payOnNext: 'روی {doc} (هنوز شروع نشده)',
    payOnOpen: 'اعمال نشده · {doc} هنوز باز است',
    figExtra: 'اضافه · تا {max}',
    figRefunded: '{amount} قبلاً مسترد شده',
    figRefundable: 'قابل استرداد',
    noCashBack: 'پولی پس داده نمی‌شود',
    noCashBackFa: 'پولی پس داده نمی‌شود',
    amount: 'مبلغ',
    amountAria: 'مبلغ استرداد',
    af: 'افغانی',
    max: 'حداکثر',
    paidFrom: 'پرداخت از · حساب نقدی',
    pickCashAccount: 'حساب نقدی را انتخاب کنید',
    note: 'یادداشت',
    required: 'الزامی',
    notePh: 'چه اتفاقی افتاده و چه کسی تایید کرده',
    notePhPaid: 'مثلاً: قطعی فایبر از ۲۵/۰۹، ۲۰ روز استفاده نشده',
    notePhCredit: 'مثلاً: نصب در این آدرس ممکن نیست',
    notePhOverpaid: 'مثلاً: ۳٬۰۰۰ برای فاکتور ۲٬۳۰۰ پرداخت شده',
    notePhCredited: 'مثلاً: پیش از فعال‌سازی به خارج رفته است',
    notePhUsed: 'مثلاً: هرگز فعال نشد، مشتری لغو کرد',
    notePhOpen: 'مثلاً: لاین هرگز نصب نشد',
    notePhNext: 'مثلاً: برای یک ماه دو بار پرداخت شده',
    notePhItems: 'مثلاً: روتر باز نشده برگشت داده شد',
    // 2 · Invoice credit
    appliedAuto: 'به‌صورت خودکار اعمال می‌شود · پرداخت صفر',
    invoiceTitle: '۲ · کریدت فاکتور',
    invoiceTableAria: 'فاکتور و کریدت آن',
    invoice: 'فاکتور',
    total: 'مجموع',
    paid: 'پرداخت‌شده',
    open: 'باز',
    amountCol: 'مبلغ',
    nowPartlyPaid: 'بخشی پرداخت‌شده',
    nowOpen: 'باز',
    nowPaid: 'پرداخت‌شده',
    crKindMemo: 'کریدیت میمو',
    crKindNone: 'بدون کریدت',
    crTitleUnchanged: 'فاکتور تغییر نمی‌کند',
    crTitleAllItems: 'همه آیتم‌ها',
    crTitleSomeItems: '{n} از {total} آیتم',
    crTitleFull: 'کریدت کامل',
    crTitlePartial: 'کریدت بخشی',
    crSubDueAgain: 'دوباره قابل پرداخت در {due}',
    crSubWillOwe: 'مشتری {amount} بدهکار می‌شود',
    crSubStaysOpen: 'باز می‌ماند',
    crSubNothing: 'چیزی کریدت نمی‌شود',
    crSubToStock: 'تجهیزات به گدام برمی‌گردد',
    crSubUnusedItems: 'آیتم‌های استفاده‌نشده',
    crSubWhole: 'تمام مبلغ استفاده‌نشده',
    crSubPart: '{cm} از {max} افغانی',
    afterOpen: 'باز {amount} · بدهکار',
    afterPaidUnchanged: 'پرداخت‌شده · بدون تغییر',
    afterFullyCredited: 'کاملاً کریدت شد',
    afterPaidCredited: 'پرداخت‌شده · {amount} کریدت',
    afterClosed: 'بسته شد',
    afterDue: 'سررسید {due}',
    afterDueAmount: 'سررسید {due} · {amount}',
    afterCancelled: 'لغو شد',
    totalRefundOut: 'مجموع پول خروجی مسترد شده',
    decisionTitle: 'با این فاکتور چه شود؟',
    decFull: 'کامل',
    decPartial: 'بخشی',
    decNone: 'بدون تغییر',
    decFullSub: 'کریدت {amount} افغانی',
    decFullSubCloses: 'کریدت {amount} افغانی · بسته می‌شود',
    decFullSubCancels: 'کریدت {amount} افغانی · لغو می‌شود',
    decPartialSub: 'بخش استفاده‌نشده را وارد کنید',
    decPartialSubItems: 'آیتم‌های استفاده‌نشده را تیک بزنید',
    decNoneSubOwe: 'مشتری بدهکار می‌شود',
    decNoneSubOpen: 'باز می‌ماند',
    decNoneSubDue: 'دوباره قابل پرداخت در {due}',
    decNoneSubNothing: 'چیزی مسترد نمی‌شود',
    creditAmountLabel: 'مبلغ کریدت · سرویس استفاده‌نشده (افغانی)',
    crHelpNegative: 'کریدت نمی‌تواند منفی باشد',
    crHelpOver: 'بیشتر از {max} افغانی',
    crHelpMax: 'حداکثر {max} افغانی',
    unusedItems: 'آیتم‌های استفاده‌نشده',
    backToStock: 'برگشت به گدام',
    // Steps
    stepCreditMemo: 'کریدیت میمو',
    stepExpense: 'مصرف (Expense)',
    stepZeroPayment: 'پرداخت صفر',
    stepToStock: ' · تجهیزات به گدام',
    stepExpenseSub: 'A/R · {account} · {location} · {class}',
    stepZeroTitle: '۰ افغانی · {n} اعمال',
    stepZeroSubEmpty: 'اسناد را اعمال می‌کند',
    linkCmInv: 'CM → {doc}',
    linkCmExp: 'CM → Expense',
    linkPayExp: '{pay} → Expense',
    linkPayExpOff: '{pay} → Expense (از {doc})',
    // Footer
    toContinue: 'برای ادامه: {missing}',
    missNegative: 'مبلغ نمی‌تواند منفی باشد',
    missAmount: 'مبلغ را وارد کنید',
    missTickItem: 'یک آیتم را تیک بزنید',
    missAmountHigh: 'مبلغ بیش از حد است',
    missNotEnoughCash: 'پول نقد کافی نیست',
    missNote: 'یادداشت بنویسید',
    missCreditHigh: 'کریدت بیش از حد است',
    missCreditNegative: 'کریدت نمی‌تواند منفی باشد',
    missNothing: 'چیزی برای ثبت نیست',
    missLocation: 'موقعیت را انتخاب کنید',
    missClass: 'کلاس را انتخاب کنید',
    missCashAccount: 'حساب نقدی را انتخاب کنید',
    missCustomer: 'مشتری را انتخاب کنید',
    ctaNothing: 'چیزی برای ثبت نیست',
    ctaSaveCredit: 'ثبت کریدت فاکتور',
    ctaRefund: 'استرداد {amount} افغانی',
    printVoucher: 'چاپ سند',
    printVoucherTitle: 'چاپ سند استرداد برای امضای مشتری',
    printed: 'چاپ شد ✓ · چاپ دوباره',
    printStale: 'چاپ دوباره · مشخصات تغییر کرده',
    printFailed: 'سند چاپ نشد',
    recordedInQbo: 'در کویک‌بوکس ثبت شد',
    savedQboFailed: 'در صندوق ثبت شد · کویک‌بوکس: {error} — از ردیف دفتر دوباره تلاش کنید',
    savedQboPending: 'در صندوق ثبت شد · همگام‌سازی کویک‌بوکس در انتظار',
    // Confirm
    confirmTitleRefund: 'استرداد {amount} افغانی به {customer}',
    confirmTitleCredit: 'کریدت {amount} افغانی روی {doc}',
    confirmSub: 'کویک‌بوکس این‌ها را ثبت می‌کند:',
    partCheck: '۱ · چک استرداد',
    partInvoice: '۲ · فاکتور',
    partInvNone: 'فاکتوری درگیر نیست',
    partInvCredit: 'کریدیت میمو · {doc}',
    partInvNoChange: 'بدون تغییر · {doc}',
    handed: 'پول نقد تحویل داده شد و رسید امضا شد',
    back: 'برگشت',
    confirm: 'تایید',
    confirmAndRefund: 'تایید و استرداد',
    toastPosted: 'استرداد {ref} ثبت شد ✓',
    toastCredit: 'کریدت فاکتور {ref} ثبت شد ✓',
    toastQboFailed: 'همگام‌سازی کویک‌بوکس ناکام شد — از ردیف دفتر دوباره تلاش کنید',
    postFailed: 'ثبت استرداد ناکام شد.'
  },
  title: 'پرداخت ها',
  hotspot: {
    title: 'پرداخت هات اسپات',
    searchPlaceholder: 'جستجوی مشتریان فروشنده با نام نمایشی یا مرجع والد...',
  },
  list: {
    title: 'لیست پرداخت ها',
    addPayment: 'افزودن پرداخت',
    noPayments: 'هیچ پرداختی یافت نشد',
    searchCustomers: 'جستجو با نام، نام کاربری، شماره تماس یا شناسه قرارداد...',
    selectCustomer: 'انتخاب مشتری',
    unknownBusiness: 'نامشخص',
    unknownCustomer: 'نامشخص',
    resetFilter: 'حذف فیلتر مشتری',
    transactionType: 'نوع تراکنش',
    allTransactions: 'همه',
    invoicesOnly: 'فاکتورها',
    paymentsOnly: 'پرداخت‌ها',
    dateFilter: {
      label: 'تاریخ',
      placeholder: 'بازه تاریخ',
      from: 'از',
      to: 'تا',
      options: {
        all: 'همه',
        today: 'امروز',
        thisWeek: 'این هفته',
        specific: 'تاریخ مشخص',
        custom: 'سفارشی',
      },
    },
    columns: {
      id: 'شناسه',
      date: 'تاریخ',
      customer: 'مشتری',
      amount: 'مبلغ',
      status: 'وضعیت',
      referenceNo: 'شماره مرجع',
      balance: 'مانده حساب',
      type: 'نوع',
      actions: 'عملیات'
    },
    types: {
      invoice: 'فاکتور',
      payment: 'پرداخت'
    },
    loading: 'در حال بارگیری...',
    loadingPayments: 'در حال بارگیری تراکنش‌ها...'
  },
  search: {
    title: 'جستجوی مشتریان',
    placeholder: 'جستجو با نام، نام کاربری، شماره تماس یا شناسه قرارداد',
    error: 'خطا در جستجو',
    noResults: 'هیچ مشتری یافت نشد',
    results: 'نتایج جستجو',
    startSearching: 'نام، نام کاربری، شماره تماس یا شناسه قرارداد را وارد کنید',
    minChars: 'حداقل ۳ کاراکتر وارد کنید',
    columns: {
      name: 'نام مشتری',
      email: 'ایمیل',
      phone: 'شماره تماس',
      actions: 'عملیات'
    }
  },
  actions: {
    pay: 'پرداخت'
  },
  form: {
    searchCustomer: 'جستجوی مشتری',
    searchPlaceholder: 'نام، نام کاربری، شماره تماس یا شناسه قرارداد را وارد کنید',
    selectedCustomer: 'مشتری انتخاب شده',
    amount: 'مبلغ',
    paymentMethod: 'روش پرداخت',
    date: 'تاریخ پرداخت',
    notes: 'یادداشت',
    error: 'خطا در پرداخت',
    selectCustomer: 'لطفا ابتدا مشتری را انتخاب کنید',
    success: 'پرداخت با موفقیت ثبت شد'
  },
  methods: {
    cash: 'نقدی',
    card: 'کارت',
    bank: 'انتقال بانکی'
  },
  status: {
    completed: 'تکمیل شده',
    pending: 'در انتظار',
    failed: 'ناموفق'
  },
  edit: {
    title: 'ویرایش پرداخت'
  },
  create: {
    title: 'پرداخت جدید'
  },
  depositTo: {
    title: 'واریز به',
    cash: 'نقدی',
    bank: 'انتقال بانکی'
  },
  common: {
    list: 'پ',
    select: 'انتخاب کنید...',
    clear: 'پاک کردن',
    change: 'تغییر',
    save: 'ذخیره',
    cancel: 'لغو',
    confirm: 'تایید',
    view: 'نمایش',
    submitting: 'در حال ثبت...',
    success: 'موفقیت',
    error: 'خطا',
    info: 'اطلاعات',
    loading: 'در حال بارگیری...',
    ok: 'تایید',
    yes: 'بلی',
  },
  receive: {
    title: 'دریافت پرداخت',
    customerInfo: 'اطلاعات مشتری',
    summary: 'خلاصه',
    openBalance: 'مانده باز',
    overduePayment: 'پرداخت معوق',
    transactionList: 'لیست تراکنش‌ها',
    serviceDetails: 'جزئیات سرویس',
    quickbooksBalance: 'بیلانس کویک بوکس',
    deltasibBalance: 'بیلانس دلتا سیب',
    package: 'پکیج',
    price: 'قیمت',
    startDate: 'تاریخ شروع',
    endDate: 'تاریخ پایان',
    addService: 'افزودن سرویس',
    cancelService: 'لغو سرویس',
    startNextService: 'شروع سرویس بعدی',
    status: 'وضعیت',
    active: 'فعال',
    inactive: 'غیرفعال',
    suspended: 'معلق',
    changeStatus: 'تغییر وضعیت',
    customerName: 'نام مشتری',
    customerId: 'شناسه قرارداد',
    selectCustomer: 'انتخاب مشتری',
    customerSelected: 'مشتری انتخاب شد',
    contractIdPlaceholder: 'شناسه قرارداد',
    paymentDate: 'تاریخ پرداخت',
    referenceNo: 'شماره مرجع',
    depositTo: 'واریز به',
    amount: 'مبلغ',
    paidAmount: 'مبلغ پرداخت شده',
    packageNo: 'شماره پکیج',
    memo: 'یادداشت',
    saveAndPrint: 'ذخیره و چاپ',
    saveAndClose: 'ذخیره و بستن',
    selectDepositAccount: 'انتخاب حساب واریز',
    searchDepositAccount: 'جستجوی حساب واریز...',
    noDepositAccountsFound: 'حساب واریزی یافت نشد',
    noBranchDepositAccounts: 'هیچ حساب واریزی برای شعبه شما تعیین نشده است',
    usageStats: {
      used: 'استفاده شده',
      remaining: 'باقی مانده',
      unlimited: 'نامحدود',
      days: 'روز',
      expired: 'منقضی شده'
    },
    devices: 'دستگاه‌ها',
    quantity: 'تعداد',
    unitPrice: 'قیمت واحد',
    totalAmount: 'مبلغ کل',
    deviceDetails: 'جزئیات دستگاه',
    servicePayment: 'پرداخت سرویس',
    devicePayment: 'پرداخت دستگاه',
    mixedPayment: 'پرداخت ترکیبی (سرویس + تجهیزات)',
    items: 'اقلام تجهیزات',
    paymentHistory: 'تاریخچه پرداخت',
    totalToBePaid: 'مجموع برای پرداخت',
    remainingBalance: 'مانده حساب',
    description: 'شرح',
    dueDate: 'تاریخ سررسید',
    unappliedPayment: 'پرداخت اعمال نشده',
    availableAmount: 'مبلغ در دسترس',
    autoApplyNote: 'این مبلغ به صورت خودکار به فاکتور انتخابی اعمال خواهد شد',
    autoApplied: 'اعمال خودکار',
    amountAdjusted: 'مبلغ به مانده حساب تنظیم شد',
    customerNotFound: 'مشتری یافت نشد',
    invalidAmount: 'لطفا مبلغ معتبر وارد کنید',
    paymentSuccess: 'پرداخت با موفقیت ثبت شد',
    depositSuccess: 'واریز با موفقیت ثبت شد',
    invoiceNotFound: 'فاکتور یافت نشد',
    // ترجمه‌های مدیریت سرویس
    selectPackage: 'انتخاب پکیج',
    selectPackageDescription: 'یک پکیج سرویس برای افزودن به این مشتری انتخاب کنید',
    searchPackages: 'جستجوی پکیج‌ها...',
    noServicesFound: 'هیچ سرویسی مطابق با جستجوی شما یافت نشد',
    noServicesAvailable: 'هیچ سرویسی در دسترس نیست',
    noDescription: 'توضیحی در دسترس نیست',
    serviceId: 'شناسه سرویس',
    type: 'نوع',
    perMonth: 'در ماه',
    failedToLoadServices: 'خطا در بارگیری سرویس‌ها',
    serviceAddedSuccessfully: 'پکیج با موفقیت اضافه شد',
    failedToAddService: 'خطا در افزودن سرویس',
    serviceRestartedSuccessfully: 'پکیج بعدی با موفقیت شروع شد',
    serviceAlreadyActive: 'این پکیج از قبل فعال است (توسط سیستم یا عملیات قبلی).',
    failedToRestartService: 'خطا در راه‌اندازی مجدد سرویس',
    serviceCanceledSuccessfully: 'سرویس با موفقیت لغو شد',
    failedToCancelService: 'خطا در لغو سرویس',
    noActiveServiceSelectNew: 'هیچ سرویس فعالی یافت نشد. لطفا سرویس جدیدی برای فعال‌سازی انتخاب کنید.',
    noActiveServiceToRestart: 'هیچ سرویس فعالی برای راه‌اندازی مجدد وجود ندارد. لطفا سرویسی برای فعال‌سازی انتخاب کنید.',
    amountReceived: 'مبلغ دریافت شده',
    amountApplied: 'مبلغ اعمال شده',
    amountCredit: 'مبلغ اعتبار',
    printMemo: 'چاپ یادداشت',
    searchByNameOrId: 'جستجو با نام یا شناسه سرویس...',
    addPendingService: 'افزودن سرویس',
    addPendingServiceDescription: 'یک پکیج سرویس برای این مشتری اضافه کنید',
    pendingServiceAddedSuccessfully: 'پکیج با موفقیت اضافه شد',
    failedToAddPendingService: 'خطا در افزودن سرویس',
    selectCustomerFirst: 'لطفا ابتدا مشتری را انتخاب کنید',
    rechargeService: 'شارژ مجدد',
    rechargeServiceDescription: 'شارژ مجدد با آخرین پکیج استفاده شده',
    serviceRechargedSuccessfully: 'پکیج با موفقیت شارژ شد',
    failedToRechargeService: 'خطا در شارژ مجدد سرویس',
    noServiceHistoryFound: 'هیچ سابقه سرویسی یافت نشد. لطفا از "افزودن سرویس" برای انتخاب پکیج استفاده کنید.',
    noPendingServicesToActivate: 'هیچ سرویس در انتظار یافت نشد. لطفا ابتدا یک سرویس اضافه کنید.',
    startNextServiceConfirm: 'این کار پکیج "{name}" را شروع می‌کند. ادامه می‌دهید؟',
    serviceChange: {
      checking: 'در حال بررسی پکیج فعلی و فاکتور QBO…',
      noQboCustomer: 'این مشتری به QuickBooks متصل نیست.',
      noActivePackage: 'پکیج فعال در DeltaSIB برای این کاربر یافت نشد.',
      originalPrice: 'قیمت اصلی',
      returnPrice: 'قیمت بازگشتی',
      packageFinished: 'این پکیج تمام شده است (حجم یا مدت زمان تمام شده).',
      qboInvoiceFound: 'فاکتور QBO یافت شد: {doc}',
      qboInvoiceNotFound: 'فاکتور QBO برای این سرویس‌بیس یافت نشد.',
      qboInvoiceTotal: 'مبلغ کل فاکتور QBO',
      qboInvoiceBalance: 'مانده QBO',
      qboInvoiceAfterCancel: 'فاکتور QBO پس از لغو',
      packageTypeVolume: 'حجمی (گیگابایت)',
      packageTypeDuration: 'مدت‌دار (روز)',
      packageTypeVolumeDuration: 'حجمی + مدت‌دار',
      usageVolume: 'مصرف {used}GB از {total}GB · باقی‌مانده {remain}GB',
      usageDays: 'مصرف {used} از {total} روز · باقی‌مانده {remain} روز',
      previewFailed: 'بارگذاری پیش‌نمایش پکیج ناموفق بود',
      missingDeltaUser: 'شناسه کاربر DeltaSIB برای این مشتری موجود نیست.',
      tableTotal: 'کل',
      tableUsed: 'مصرف‌شده',
      tableOriginalPrice: 'قیمت اصلی',
      tableReturnPrice: 'قیمت بازگشتی',
      tableUsedCost: 'هزینه مصرف‌شده',
      cancelRefundNote: 'برای پکیج فعال فعلی، پرداخت بازپرداخت CancelService ایجاد خواهد شد.',
      newPackageCardTitle: 'پکیج جدید',
      pendingOnlyTitle: ' جدید به‌صورت در انتظار',
      pendingOnlyHint: 'یک بسته جدید به حالت انتظار اضافه می‌شود تا پس از اتمام بسته فعلی آغاز شود. بسته فعالِ کنونی بدون تغییر باقی مانده و کنسل نمی‌شود.',
      replacePackageCardTitle: 'جایگزینی پکیج فعال',
      currentServiceKeptBanner: 'پکیج فعال فعلی فعال می‌ماند. پکیج جدید به‌صورت در انتظار در صف اضافه می‌شود.',
      dialogDescriptionPendingOnly: 'پکیج جدید را انتخاب کنید. بدون تغییر سرویس فعال فعلی، به‌صورت در انتظار اضافه می‌شود.',
      currentActivePackage: 'پکیج فعال فعلی',
      unfinishedServiceBanner: 'این مشتری هنوز یک پکیج فعال دارد که تمام نشده است.',
      unfinishedServiceDetail: 'حجم یا زمان باقی‌مانده در سرویس فعلی وجود دارد.',
      willBeCanceledBanner: 'با ادامه، این پکیج لغو می‌شود (وضعیت → Cancel) و سپس پکیج جدید اضافه می‌شود.',
      badgeActive: 'فعال',
      badgeNotFinished: 'تمام نشده',
      badgeWillCancel: 'لغو خواهد شد',
      dialogDescriptionWithCancel: 'پکیج جدید را انتخاب کنید. ابتدا پکیج فعال فعلی لغو می‌شود.',
      noUnfinishedToCancel: 'پکیج فعال تمام‌نشده‌ای وجود ندارد — فقط پکیج جدید اضافه می‌شود.',
      activePackageAlreadyFinished: 'پکیج فعال فعلی قبلاً تمام شده — لغو نمی‌شود.',
      finishedPackageBanner: 'پکیج فعلی تمام یا منقضی شده است. از «افزودن و فعال‌سازی» استفاده کنید — پکیج در انتظار پس از چند دقیقه توسط سیستم خودکار فعال می‌شود.',
      badgeFinished: 'تمام شده',
      dialogDescriptionFinishedRecharge: 'پکیج را انتخاب کنید تا بلافاصله اضافه و فعال شود. پکیج تمام‌شده لغو نمی‌شود.',
      applyInBalance: 'اعمال در موجودی',
      applyInBalanceHint: 'هزینه بسته فعلی بر اساس میزان حجم و مدت زمان استفاده‌شده محاسبه و کسر می‌گردد. مبلغ باقی‌مانده به بیلانس مشترک افزوده شده، بسته فعلی کنسل و بسته جدید آغاز می‌شود.',
      forceCancel: 'لغو اجباری',
      forceCancelHint: 'بسته فعلی بدون کسر هیچ هزینه‌ای کنسل شده و کل مبلغ مسترد میگردد؛ سپس بسته جدید آغاز می‌شود.',
      forceCancelNotAllowed: 'لغو اجباری فقط وقتی هزینه مصرف‌شده کمتر از {max} باشد مجاز است (هزینه فعلی: {amount}).',
      addAsPending: 'افزودن در انتظار',
      addAndActive: 'افزودن و فعال‌سازی',
      pendingSuccess: 'سرویس با موفقیت به‌صورت در انتظار اضافه شد',
      activatedSuccess: 'سرویس با موفقیت تغییر و فعال شد',
      changeFailed: 'تغییر پکیج سرویس ناموفق بود',
    },
  },
  print: {
    paymentReceipt: 'رسید پرداخت',
    invoiceReceipt: 'رسید فاکتور',
    paymentDetails: 'جزئیات پرداخت',
    paymentDate: 'تاریخ پرداخت',
    memo: 'یادداشت',
    button: 'چاپ رسید',
    companyName: 'نام شرکت مشتری',
    receiptTitle: 'دریافت شده از',
    dateReceived: 'تاریخ',
    receiptNumber: 'شماره',
    amount: 'مبلغ',
    startDate: 'تاریخ شروع',
    endDate: 'تاریخ ختم',
    unappliedPayment: 'پرداخت اعمال نشده',
    invoice: 'فاکتور',
    customerDetails: 'خدمات / محصولات',
    customerName: 'نام کامل مشتری به اضافه آی دی مشتری',
    servicesProducts: 'خدمات / محصولات',
    packageOrService: 'پکیج / سرویس',
    activeServiceId: 'شماره',
    description: 'توضیحات',
    noDescription: 'بدون توضیحات',
    subtotal: 'مجموع اقلام',
    amountPaid: 'پرداخت شده',
    remainingBalance: 'باقی مانده',
    paymentHistory: 'تاریخ شروع و ختم بسته',
    createdBy: 'ایجاد شده از',
    dateTimeCreated: 'تاریخ و ساعت ایجاد',
    noItems: 'بدون آیتم',
    thankYou: 'متشکرم از انتخاب شما!'
  },
  deltaSibStatus: {
    openButton: 'وضعیت دلتاسیب',
    title: 'دلتاسیب / VISP',
    tabVisp: 'VISP',
    tabStatus: 'وضعیت',
    currentVisp: 'VISP فعلی',
    currentStatus: 'وضعیت فعلی',
    setVisp: 'تغییر VISP',
    setStatus: 'تغییر وضعیت',
    apply: 'اعمال',
    vispHint: 'VISP از طریق API به‌روز می‌شود؛ پس از ذخیره، هدر نیز به‌روز می‌شود.',
    statusHint: 'از API وضعیت دلتاسیب استفاده می‌شود (مشابه کلاینت قدیمی).',
    error: 'خطای وضعیت',
    missingSelection: 'ابتدا یک وضعیت انتخاب کنید.',
    missingVisp: 'ابتدا VISP را انتخاب کنید.',
    statusUpdated: 'وضعیت با موفقیت به‌روز شد.',
    vispUpdated: 'VISP با موفقیت به‌روز شد.',
    needLinkedUser: 'مشتری متصل به دلتاسیب را انتخاب کنید.',
    triggerVispPrefix: 'VISP:',
    triggerStatusPrefix: 'وضعیت:',
    openVispDialog: 'تنظیمات VISP',
    openStatusDialog: 'تنظیمات وضعیت',
    statusEnable: 'فعال',
    statusDisable: 'غیرفعال'
  },
  transfer: {
    drawerTitle: 'حواله نقدی',
    drawerSub: 'انتقال پول از {from} به {to} · {method}',
    methodSarrafi: 'از طریق صرافی',
    methodHand: 'به‌صورت دستی',
    draft: 'پیش‌نویس',
    inTransit: 'در راه',
    received: 'دریافت شد',
    from: 'از',
    to: 'به',
    leavesNow: 'همین حالا کم می‌شود',
    left: 'کم شد',
    onConfirm: 'پس از تأیید دریافت',
    arrived: 'رسید',
    amountToTransfer: 'مبلغ حواله',
    sendAll: 'ارسال کل موجودی',
    transferDate: 'تاریخ حواله',
    refNo: 'شماره سند',
    auto: 'خودکار',
    howMoneyMoving: 'روش انتقال پول',
    throughSarrafi: 'از طریق صرافی (حواله)',
    handCarry: 'انتقال دستی',
    hawalaDetails: 'مشخصات حواله',
    hawalaCode: 'کد حواله',
    sarrafiSlip: 'رسید صرافی',
    attachSlipPhoto: 'افزودن عکس رسید حواله',
    sendingInfo: 'مشخصات ارسال',
    sendingSarrafi: 'صرافی فرستنده',
    senderName: 'نام فرستنده',
    phone: 'شماره تماس',
    receivingInfo: 'مشخصات دریافت',
    payingSarrafiDest: 'صرافی مقصد (پرداخت‌کننده)',
    receiverName: 'نام گیرنده',
    whoCollectsCash: 'نام کسی که پول را می‌گیرد',
    sarrafiCommission: 'کمیشن صرافی',
    whoPaysCommission: 'کمیشن از کجا پرداخت می‌شود؟',
    onTopOfAmount: 'جدا از مبلغ',
    deductedFromAmount: 'کسر از مبلغ',
    cashOutOf: 'خروج از {name}',
    transferToDestination: 'Transfer به مقصد',
    commissionVoucher: 'سند پرداخت کمیشن',
    receiverCollects: 'گیرنده دریافت می‌کند',
    recordCommissionCheckbox: 'کمیشن را به‌عنوان سند پرداخت (Cheque) در «مصارف بانکی» ثبت کن',
    handCarryDetails: 'مشخصات انتقال دستی',
    carriedBy: 'نام حامل',
    expectedArrival: 'زمان تخمینی رسیدن',
    attachSignedNote: 'افزودن عکس سند امضاشده تحویل',
    readyToSend: 'آماده ارسال',
    saveDraft: 'ذخیره پیش‌نویس',
    reviewAndSend: 'بررسی و ارسال',
    hawalaSent: 'حواله ارسال شد',
    transferReceived: 'حواله دریافت شد',
    tracking: 'پیگیری حواله',
    stepRecordedInLedger: 'در دفتر صندوق {name} ثبت شد',
    stepWaitingForConfirm: 'منتظر تأیید دریافت در {name}',
    stepReceivedAt: 'در {name} دریافت شد',
    stepReceiverCollects: '{name} با کد {code} از {sarrafi} تحویل می‌گیرد',
    stepQboTransfer: 'Transfer کوئیک‌بوکس',
    stepQboRecorded: 'Transfer #1832 در QBO ثبت شد',
    stepPostedAfterConfirm: 'بعد از تأیید دریافت ثبت می‌شود',
    stepVoucherQueued: 'در صف همگام‌سازی · مصارف بانکی',
    confirmReceipt: 'تأیید دریافت',
    copyForReceiver: 'کپی برای گیرنده',
    copied: 'کپی شد ✓',
    newTransfer: 'حواله جدید',
    afterConfirmation: 'بعد از تأیید'
  }
}